import { render, staticRenderFns } from "./StatisticsPremiumPage.vue?vue&type=template&id=7a67ab99&scoped=true"
import script from "./StatisticsPremiumPage.vue?vue&type=script&lang=js"
export * from "./StatisticsPremiumPage.vue?vue&type=script&lang=js"
import style0 from "./StatisticsPremiumPage.vue?vue&type=style&index=0&id=7a67ab99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a67ab99",
  null
  
)

export default component.exports